/**
 * 数字や実績に添える月桂樹。形は Figma から書き出した本物のシルエットを使う。
 *
 * PNG 書き出し (laurel-gold.png) は背景が白で塗り潰されていて、クリーム地に
 * 置くと白い箱が出た。透過が無いので、色は CSS 側で作る。
 * /assets/laurel.svg を mask にして、金は下のグラデを敷いて出す。
 * 濃い地の上では color を渡して単色に染める。
 *
 * 手で svg を描くのはやめた。葉の重なりと反りが本物と全く違って、
 * 「それっぽい図形」にしかならなかった。
 */

import { sitePath } from "@/lib/site-path";

const RATIO = 23.4495 / 52.1606;

/** 元アセットから拾った金。上/中/下の平均が #D3B84B / #E5CC6C / #D5BB50 */
const GOLD = "linear-gradient(180deg, #CDAF3C 0%, #E9D07A 48%, #CDB248 100%)";

export function Laurel({
  color,
  flip = false,
  height = 26,
}: {
  /** 省略すると金のグラデ。色を渡すとその単色に染める */
  color?: string;
  flip?: boolean;
  height?: number;
}) {
  const width = Math.round(height * RATIO * 100) / 100;
  const maskImage = `url(${sitePath("/assets/laurel.svg")})`;

  return (
    <span
      aria-hidden
      className="shrink-0"
      style={{
        display: "inline-block",
        width,
        height,
        background: color ?? GOLD,
        transform: flip ? "scaleX(-1)" : undefined,
        WebkitMaskImage: maskImage,
        maskImage,
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
      }}
    />
  );
}
